import { motion } from "framer-motion";
import { MessageCircle, ClipboardList, Truck, Wrench, ArrowUpRight } from "lucide-react";
import { WA_LINK } from "@/lib/constants";

const STEPS = [
  {
    num: "01",
    icon: MessageCircle,
    title: "Hubungi Kami",
    desc: "Klik tombol WhatsApp di halaman ini untuk terhubung langsung dengan kami.",
  },
  {
    num: "02",
    icon: ClipboardList,
    title: "Jelaskan Masalah",
    desc: "Ceritakan keluhan peralatan dan lokasi Anda — kirim foto unit jika perlu.",
  },
  {
    num: "03",
    icon: Truck,
    title: "Teknisi Datang",
    desc: "Teknisi datang ke lokasi Anda sesuai jadwal yang disepakati.",
  },
  {
    num: "04",
    icon: Wrench,
    title: "Peralatan Diperiksa & Diperbaiki",
    desc: "Diagnosa di tempat, estimasi biaya jelas sebelum pengerjaan dimulai.",
  },
];

export default function Process() {
  return (
    <section id="proses" data-testid="process-section" className="py-24 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 lg:mb-24"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Cara Kerja )</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-5xl md:text-6xl lg:text-7xl">
            Cara pesan
            <br />
            <span className="text-stroke">service.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`process-step-${step.num}`}
              className="group relative bg-white p-8 lg:p-10 hover:bg-[#eef4f7] transition-colors duration-500"
            >
              <span className="font-display font-extrabold text-6xl lg:text-7xl leading-none text-stroke group-hover:text-stroke-cyan transition-colors duration-500">
                {step.num}
              </span>
              <step.icon size={26} className="mt-8 text-brand-ink" />
              <h3 className="mt-4 font-display font-bold text-xl uppercase tracking-tight">{step.title}</h3>
              <p className="mt-3 text-sm text-ink/50 leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-14 text-center"
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="process-whatsapp-button"
            aria-label="Pesan service via WhatsApp"
            className="group inline-flex items-center gap-3 rounded-full bg-brand px-8 py-4 font-display font-bold text-black hover:bg-ink hover:text-white transition-colors duration-300"
          >
            Pesan Service via WhatsApp
            <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
